import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  
  suscrip:string = "";
  susSent = false;
  suscripBtn:boolean = true;


  form = {
    nombre:"",
    email:"",
    asunto:"",
    mensaje:""
  }

  formSent = false;
  formBtn:boolean = true;

  constructor(private httpServ:HttpService) { }

  ngOnInit(): void {
  }


  verifySuscrip():void {
    if (this.verifyEmail(this.suscrip)) {
      this.suscripBtn = false; 
    }else{
      this.suscripBtn = true;
    }
  }

  sendSuscrib():void {
    this.httpServ.post('suscription',{email:this.suscrip}).then((result:any) => {
    }).catch((err)=> {
    });    
    this.susSent = true;
    this.suscrip = "";
  }

  sendForm():void {
    this.httpServ.post('form',this.form).then((result:any) => {
    }).catch((err)=> {
    });
    this.formSent = true;
    this.form.nombre = "";
    this.form.email = "";
    this.form.asunto = "";
    this.form.mensaje = "";
    this.formBtn = true;
  }

  verifyform():void {
    if (this.form.nombre === "" || this.form.email === "" || this.form.asunto === "" || this.form.mensaje === "") {
      this.formBtn = true;
    }else{
      if (this.verifyEmail(this.form.email)) {
        this.formBtn = false; 
      }else{
        this.formBtn = true;
      }
    }
  }

  verifyEmail(email: string):boolean{
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

}
